export const membersList = [
  {
    memberImage:
      "https://i.ibb.co/Wf8n64D/Whats-App-Image-2021-11-21-at-22-10-09.jpg",
    memberName: "abir",
  },
  {
    memberImage:
      "https://i.ibb.co/JzN2qB2/Whats-App-Image-2021-11-21-at-22-10-08.jpg",
    memberName: "bony",
  },

  {
    memberImage:
      "https://i.ibb.co/D9fcmdr/Whats-App-Image-2021-11-21-at-22-10-12.jpg",
    memberName: "rizwan",
  },
  {
    memberImage:
      "https://i.ibb.co/Jr71ZRL/Whats-App-Image-2021-11-21-at-22-10-10.jpg",
    memberName: "shouvik",
  },
  {
    memberImage:
      "https://i.ibb.co/KN4P3hg/Whats-App-Image-2021-11-21-at-22-10-11.jpg",
    memberName: "sara",
  },

  {
    memberImage:
      "https://i.ibb.co/3rqccz8/Whats-App-Image-2021-11-21-at-22-10-10-1.jpg",
    memberName: "prince",
  },

  {
    memberImage:
      "https://i.ibb.co/djRTxt9/Whats-App-Image-2021-11-21-at-22-10-11-1.jpg",
    memberName: "sakib",
  },
  {
    memberImage:
      "https://i.ibb.co/QYP4Lrf/Whats-App-Image-2021-11-21-at-22-10-12-1.jpg",
    memberName: "rahat",
  },
  {
    memberImage:
      "https://i.ibb.co/h7FvDYf/Whats-App-Image-2021-11-21-at-22-10-13-1.jpg",
    memberName: "kamrul",
  },
  {
    memberImage:
      "https://i.ibb.co/x630YQM/Whats-App-Image-2021-11-21-at-22-10-13.jpg",
    memberName: "diptesh",
  },
  {
    memberImage:
      "https://i.ibb.co/ncrGdfz/Whats-App-Image-2021-11-21-at-22-10-14.jpg",
    memberName: "yasin",
  },
];
